














import { Component, Mixins, Vue, Prop } from "vue-property-decorator"
import ListLayout from "../components/layouts/ListLayout.vue"
import { WebinarDataService } from "@/services/WebinarDataServices"
import { WebinarInfo } from "../models/WebinarInfo"
import "../assets/_base.scss"
import { AwEventStore } from "../models/AwEventStore"
import { AwEventType } from "../models/AwEventType"
import setThemeData from "../services/setThemeData"
import Color from "../services/Color"
import { AnalyticsClient } from "@/services/AnalyticsService"
import { container } from "tsyringe"
import { getFullVideo } from "@/services/getFullVideoData"
@Component({
  components: {
    ListLayout
  }
})
export default class AmplilyWidget extends Vue {
  data() {
    return {
      webinarId: -1,
      webinarData: undefined,
      loadingmsg: "Loading video..."
    }
  }
  get themeCss() {
    let color = new Color(this.$root.$data.theme_data.theme_color)
    color.a = 0.4
    return {
      "--font-color": this.$root.$data.theme_data.font_color,
      "--font-size": this.$root.$data.theme_data.font_size + "pt", //default is 11pt
      "--font-family": this.$root.$data.theme_data.font_family,
      "--theme-color": this.$root.$data.theme_data.theme_color,
      "--theme-contrast": color.islight() ? `#000000` : `#ffffff`,
      "--theme-contrast-brightness": color.islight()
        ? `rgba(0,0,0,0.2)`
        : `rgba(255,255,255,0.2)`,
      "--font-size-22":
        (this.$root.$data.theme_data.font_size + 11).toString() + "pt",
      "--font-size-12":
        (this.$root.$data.theme_data.font_size + 1).toString() + "pt",
      "--font-size-14":
        (this.$root.$data.theme_data.font_size + 3).toString() + "pt",
      "--font-size-18":
        (this.$root.$data.theme_data.font_size + 7).toString() + "pt",
      "--colored-playicon": `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' height='24' viewBox='0 0 24 24' width='24'%3E%3Cpath d='M8 5v14l11-7z' fill='${
        color.islight() ? `%23000000` : `%23ffffff`
      }'/%3E%3Cpath d='M0 0h24v24H0z' fill='none'/%3E%3C/svg%3E")`
    }
  }
  fetchId = document.getElementsByClassName("parmonic-widget")[0]
    ? (document.getElementsByClassName(
        "parmonic-widget"
      )[0] as HTMLElement).getAttribute("data-w-id") ?? ""
    : ""
  _dataService = container.resolve(WebinarDataService)
  _analytics = container.resolve(AnalyticsClient)
  created() {
    this._analytics = container.resolve(AnalyticsClient)
    this._dataService = container.resolve(WebinarDataService)
    this.loadData()
  }
  loadData() {
    this._dataService.getData(this.fetchId).then(returnValue => {
      this.$data.loadingmsg = "Couldn't load the video."
      if (returnValue == undefined) {
        this.$root.$data.logger.error(
          `Parmonic Widget error: Webinar not found`
        )
        return
      }
      this.$data.webinarData = returnValue as WebinarInfo
      this.$data.webinarId = this.$data.webinarData.id
      setThemeData(this.$data.webinarData.theme_data, this)
      this._analytics.setUp(
        this.$data.webinarId,
        this.$root.$data.identifierKey,
        this.$root.$data.analyticsEventsCaptureEndPoint
      )
      var event: AwEventStore = { eventType: AwEventType.WebinarViewed }
      this._analytics.register(event, this.$root.$data.identifierKey)
      getFullVideo(this.$data.webinarData).then(returnValue => {
        this.$root.$data.fullVideoInfo = returnValue
      })
    })
  }
}
